import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {TimelineLite} from "gsap";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";

export class TractorBeamBeforeSpinStopController extends BeforeSpinStopPresentationController {

    private _randomStackedTriggered:boolean;
    private _randomStackedOverlayReels:boolean [];
    private _reelSetName:string;
    private _randomStackSymbol:string;
    private _mode:string;

    constructor(index:number) {
        super(index, "TractorBeamBeforeSpinStopController");

        /*this._randomStackView =  new TractorBeamRandomStackView([ // only map of top sym/reel is needed
                [0, 0], // r1
                [1, 0], // r2
                [2, 0], // r3
                [3, 0], // r4
                [4, 0], // r5
            ],
            [
                [0, 0],[0, 1],[0, 2], // r1
                [1, 0],[1, 1],[1, 2], // r2
                [2, 0],[2, 1],[2, 2], // r3
                [3, 0],[3, 1],[3, 2], // r4
                [4, 0],[4, 1],[4, 2]  // r5
            ]
        );*/
    }

    protected getSpinStopDelay(data:TractorBeamParsedGameData):number {
        return GameSetting.isFastSpin ? 1 : 2;
    }

    protected parseFeatureTriggered(data:TractorBeamParsedGameData):boolean {
        this._randomStackedOverlayReels = data.randomStackedOverlayReels;
        this._randomStackedTriggered = data.randomStackedTriggered;
        this._mode = data.mode;
        //this._isAborted = false;

        if(data.randomStackedTriggered) {
            const stackReelIndex = this._randomStackedOverlayReels.indexOf(true);
            const reels = data.reels;
            this._randomStackSymbol = reels[stackReelIndex][0];
            this._reelSetName = this.getReelSetName(this._randomStackSymbol);
        } else {
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
        }
        return (this._randomStackedTriggered || (this._mode === "NORMAL"))
    }

    public tryStartPresentation(data:TractorBeamParsedGameData):number {

        if(this.parseFeatureTriggered(data)) {
            this._isPlaying = true;
            this._timeline = new TimelineLite({onComplete : () => this.finish()});
            this.startPresentation(this._timeline);

            if(!this._randomStackedTriggered) {
                return 0;
            } else {
                return this.getSpinStopDelay(data);
            }
        }
        return 0;
    }

    private getReelSetName(switchSymbol:string):string {
        switch(switchSymbol) {
            case "M1" :
                return "RANDOM_STACK_M1";

            case "M2" :
                return "RANDOM_STACK_M2";

            case "M3" :
                return "RANDOM_STACK_M3";

            case "M4" :
                return "RANDOM_STACK_M4";

            default :
                return "BASE_REELSET";
        }
    }

    protected startPresentation(timeline:TimelineLite):void {
        //if(!this._isAborted) {
        if(this._randomStackedTriggered) {
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : this._reelSetName}));
            //timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: this._reelSetName})));
            //timeline.play();
        } else {
            //EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : "BASE_REELSET"}));
            //timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: "BASE_REELSET"})));
            //timeline.play();
        }
        //}
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted && this._randomStackedTriggered) {
            TractorBeamGameModuleConfig.tractorBeamRandomFeatureController.onSkip();
            //this._timeline.pause();
            //this._timeline.kill();
        }
        //TODO:Do Abort
    }

    protected resetFeature() {
        //TODO: Do reset?
    }


}
